import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const navLinks = [
  { label: 'Beneficios', href: '#beneficios', internal: false },
  { label: 'Cómo funciona', href: '#como-funciona', internal: false },
  { label: 'Métricas', href: '#metricas', internal: false },
  { label: 'Comparativa', href: '#comparativa', internal: false },
  { label: 'Precio', href: '#precio', internal: false },
  { label: 'FAQ', href: '#faq', internal: false },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-stone-100'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          className="flex items-center gap-3"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
        >
          <img
            src="https://static.readdy.ai/image/9bbec872eb58a17c0d56a007cba2726b/be68cadd3dfd5e837ffeaf266bc03c46.jpeg"
            alt="HELIX Ring Logo"
            className="h-9 w-9 object-cover rounded-full"
          />
          <span
            className={`font-display text-xl font-semibold tracking-widest transition-colors duration-300 ${
              scrolled ? 'text-stone-900' : 'text-white'
            }`}
          >
            HELIX
          </span>
        </a>

        {/* Desktop Nav */}
        <ul className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <li key={link.href}>
              <button
                onClick={() => handleNavClick(link.href)}
                className={`font-body text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-amber-700 ${
                  scrolled ? 'text-stone-600' : 'text-white/80 hover:text-white'
                }`}
              >
                {link.label}
              </button>
            </li>
          ))}
          <li>
            <button
              onClick={() => navigate('/seguimiento')}
              className={`font-body text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-amber-700 flex items-center gap-1.5 ${
                scrolled ? 'text-stone-600' : 'text-white/80 hover:text-white'
              }`}
            >
              <i className="ri-truck-line text-sm" />
              Seguimiento
            </button>
          </li>
        </ul>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <button
            onClick={() => handleNavClick('#precio')}
            className="whitespace-nowrap bg-amber-700 hover:bg-amber-800 text-white text-sm font-medium tracking-wide px-5 py-2.5 rounded-full transition-all duration-200 cursor-pointer"
          >
            Comprar ahora
          </button>
        </div>

        {/* Mobile Toggle */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer transition-colors duration-200 ${
            scrolled ? 'text-stone-800' : 'text-white'
          }`}
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Abrir menú"
        >
          {mobileOpen ? (
            <i className="ri-close-line text-xl" />
          ) : (
            <i className="ri-menu-3-line text-xl" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden bg-white/98 backdrop-blur-md border-t border-stone-100 overflow-hidden transition-all duration-300 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="text-left text-stone-700 font-body text-sm font-medium py-2 border-b border-stone-100 cursor-pointer hover:text-amber-700 transition-colors whitespace-nowrap"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => { setMobileOpen(false); navigate('/seguimiento'); }}
            className="text-left text-stone-700 font-body text-sm font-medium py-2 border-b border-stone-100 cursor-pointer hover:text-amber-700 transition-colors whitespace-nowrap flex items-center gap-2"
          >
            <i className="ri-truck-line text-sm" />
            Seguimiento
          </button>
          <button
            onClick={() => handleNavClick('#precio')}
            className="whitespace-nowrap bg-amber-700 text-white text-sm font-medium tracking-wide px-5 py-3 rounded-full cursor-pointer hover:bg-amber-800 transition-colors mt-2"
          >
            Comprar ahora
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
